<script>
import { mapActions, mapState } from 'vuex';
import NonDynamicTransportOverviewList from '../../components/non-dynamic-transport/NonDynamicTransportOverviewList';
import TwTitleBar from '../../components/TwTitleBar';

export default {
  name: 'NonDynamicTransportOverview',
  components: {
    TwTitleBar,
    NonDynamicTransportOverviewList,
  },
  data() {
    return {
      breadcrumbs: [
        { text: this.$t('menu.nonDynamicTransport.title'), to: '', disabled: true },
        { text: this.$t(`breadcrumbs.${this.$route.name}`), to: this.$route.path },
      ],
    };
  },
  computed: {
    ...mapState({
      loading: state => state.nonDynamicTransport.overview.loading,
      createLoading: state => state.nonDynamicTransport.create.loading,
      createError: state => state.nonDynamicTransport.create.error,
      nonDynamicTransports: state => state.nonDynamicTransport.overview.items,
    }),
  },
  methods: {
    ...mapActions({
      getNonDynamicTransports: 'nonDynamicTransport/getNonDynamicTransports',
    }),
  },
  created() {
    this.getNonDynamicTransports(true);
  },
};
</script>

<template>
  <v-content>
    <tw-title-bar
      :title="$t('menu.nonDynamicTransport.pages.overview.title')"
      :breadcrumbs="breadcrumbs">
    </tw-title-bar>
    <non-dynamic-transport-overview-list
      :items="nonDynamicTransports"
      :loading="loading"
      @create="$router.push({name:'NonDynamicTransportCreate'})"
      @refresh="getNonDynamicTransports"/>
  </v-content>
</template>



// WEBPACK FOOTER //
// src/pages/non-dynamic-transport/NonDynamicTransportOverview.vue